module.exports = __webpack_public_path__ + "static/media/slider1.be518a0f.jpg";